<template>
  <el-card>
    <el-row type="flex" justify="space-between" ref="barparent">
      <div class="flex_wrap">
        <div class="flex_box_center">
          <span>营业日期&nbsp;&nbsp;</span>
          <el-date-picker v-model="query.businessDate" :picker-options="pickerOptionsStart" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" style="width: 68%"></el-date-picker>
        </div>
        <div class="flex_box_center" v-if="isSales">
          &nbsp;&nbsp;
          <span>餐别选择&nbsp;&nbsp;</span>
          <el-select multiple clearable v-model="query.setMealIds" style="width: 68%">
            <el-option :value="undefined" label="所有"></el-option>
            <el-option v-for="(item, index) in mealListData" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
      </div>
      <div style="margin: 6px 10px; min-width: 200px; text-align: right">
        <el-button style="margin: 6px 10px" @click="hanleQuery" type="primary">查询</el-button>
        <el-button type="primary" @click="handlePrint('print')">打印</el-button>
        <el-button type="primary" @click="handlePrint('preview')">打印预览</el-button>
        <el-button type="primary" v-if="isExport" @click="handleExport">导出</el-button>
      </div>
    </el-row>
  </el-card>
</template>

<script>
import DateUtils from '@/utils/DateUtils';

export default {
  props: {
    isExport: {
      type: Boolean,
      default: true,
    },
    isSales: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      options: [],
      mealListData: [],
      query: {
        setMealIds: [],
        businessDate: DateUtils.formatDate(new Date(), 'yyyy-MM-dd '),
      },
      pickerOptionsStart: {
        disabledDate: time => {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  created() {
    if (this.isSales) {
      this.getMealListData();
    }
  },
  methods: {
    hanleQuery() {
      //   console.log(this.query);
      this.$bus.$emit('todoQuery', this.query);
    },
    //销售员
    getMealListData() {
      this.$axios({
        methods: 'get',
        url: this.api.getMealCategory,
      }).then(res => {
        this.mealListData = res.data.data;
      });
    },
    //打印
    handlePrint(type) {
      this.$bus.$emit('todoPrintCatering', type);
    },
    handleExport() {
      this.$bus.$emit('todoExportCatering');
    },
  },
};
</script>

<style lang="scss" scoped>
.el-card {
  width: 100%;

  .flex_wrap {
    flex-wrap: nowrap;
    margin-top: 10px;
  }
}
</style>
